import { useState } from 'react';
import { createStyles } from '@mantine/core';

import { useIsFeatureEnabled } from '~/hooks/useIsFeatureEnabled';
import { FEATURE } from '~/common/enums/feature.enum';

import useSubmitWithdrawal from './hooks/useSubmitWithdrawal';
import { WithdrawalFormPaymentType } from './WithdrawalFormPaymentType';
import { WithdrawalFormWithdrawal } from './WithdrawalFormWithdrawal';

const MAX_STEPS = 2;

const useStyles = createStyles(() => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    flex: 1,
  },
}));

type WithdrawalFormProps = {
  onModalClose?: () => void;
  mode?: 'withdrawal' | 'refund';
  onModeChange?: (mode: 'withdrawal' | 'refund') => void;
};

function WithdrawalForm({
  onModalClose,
  mode = 'withdrawal',
  onModeChange,
}: WithdrawalFormProps = {}) {
  const [activeStep, setActiveStep] = useState(0);
  const { classes } = useStyles();

  const isAeropayEnabled = useIsFeatureEnabled(FEATURE.ENABLE_AEROPAY);

  const scrollToTop = () =>
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

  const nextStep = () => {
    setActiveStep((current) => (current < MAX_STEPS - 1 ? current + 1 : current));
    scrollToTop();
  };
  const prevStep = () => {
    setActiveStep((current) => (current > 0 ? current - 1 : current));
    scrollToTop();
  };

  const { handleSubmit, isWithdrawing } = useSubmitWithdrawal();

  return (
    <form onSubmit={handleSubmit} className={classes.form}>
      {(() => {
        switch (activeStep) {
          case 0:
            return (
              <WithdrawalFormPaymentType
                nextStep={nextStep}
                isAeropayEnabled={isAeropayEnabled}
                onModalClose={onModalClose}
                mode={mode}
                onModeChange={onModeChange}
              />
            );
          case 1:
            return <WithdrawalFormWithdrawal prevStep={prevStep} isWithdrawing={isWithdrawing} />;
          default:
            return null;
        }
      })()}
    </form>
  );
}

export default WithdrawalForm;
